import { render, staticRenderFns } from "./daily-office.vue?vue&type=template&id=c24184f2&scoped=true"
import script from "./daily-office.vue?vue&type=script&lang=js"
export * from "./daily-office.vue?vue&type=script&lang=js"
import style0 from "./daily-office.vue?vue&type=style&index=0&id=c24184f2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24184f2",
  null
  
)

export default component.exports